import { useApolloClient } from "@apollo/client";
import { v4 as uuid } from "uuid";
import { useReactiveVar } from "@apollo/client";
import { currentShopifyVersionVar } from "../helpers/client";
import { resolvePlatformName } from "../cache/platformName";
import { AddVariantFragmentDoc } from "../types";
export function useAddVariantsWithDescriptions(productId) {
    const client = useApolloClient();
    const currentShopifyVersion = useReactiveVar(currentShopifyVersionVar);
    return (descriptions) => {
        if (!Array.isArray(descriptions) || descriptions.length === 0)
            return;
        client.cache.modify({
            id: `Product:${productId}`,
            fields: {
                variants(existingRefs = [], { readField }) {
                    let refs = existingRefs || [];
                    for (const description of descriptions) {
                        const newVariant = {
                            id: uuid(),
                            __typename: "Variant",
                            description,
                            additionalCost: { amount: 0 },
                            platformName: resolvePlatformName({}, currentShopifyVersion),
                            platformId: "",
                            curationExcludeProducts: [],
                            curationIncludeVariants: [],
                            curationSearchTerms: "",
                            curationStatus: "APPROVED",
                            curationError: null,
                            flagReason: null,
                        };
                        const ref = client.cache.writeFragment({ fragment: AddVariantFragmentDoc, data: newVariant });
                        if (!refs.some((r) => readField("id", r) === newVariant.id))
                            refs = [...refs, ref];
                    }
                    return refs;
                },
            },
        });
    };
}
